import React from 'react';

const timeline = [
  {
    id: 1,
    title: '🎉 Joined Million2Trillion',
    date: 'Apr 12, 2025',
  },
  {
    id: 2,
    title: '✅ Completed KYC Verification',
    date: 'Apr 15, 2025',
  },
  {
    id: 3,
    title: '📈 Posted First Signal',
    date: 'Apr 19, 2025',
  },
  {
    id: 4,
    title: '💼 Hired First Freelancer',
    date: 'May 02, 2025',
  },
  {
    id: 5,
    title: '🏅 Unlocked “Multi-Role Pro” Badge',
    date: 'May 16, 2025',
  },
];

export default function UserTimelineBox() {
  return (
    <div className="bg-white shadow rounded-lg p-4 mb-6">
      <h3 className="text-sm font-semibold text-gray-800 mb-3">📍 Your Journey Timeline</h3>
      <ul className="text-sm text-gray-700 space-y-3">
        {timeline.map((item) => (
          <li key={item.id} className="relative pl-4 border-l-2 border-blue-400">
            <div className="absolute left-[-5px] top-1 w-2 h-2 rounded-full bg-blue-500" />
            <div className="font-medium">{item.title}</div>
            <div className="text-xs text-gray-500">{item.date}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}
